import type { SVGProps } from "react";

export default function FolderIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.9502 3C7.34582 3 7.51184 3.00093 7.66895 3.01562C8.36989 3.08117 9.03515 3.35638 9.57715 3.80566C9.69856 3.90635 9.81596 4.02395 10.0957 4.30371L10.6465 4.85352C11.4423 5.64931 11.9051 6.11899 12.4688 6.43262C12.7705 6.60049 13.0909 6.73247 13.4229 6.82715C14.0431 7.00396 14.7028 7 15.8281 7H16.2021C17.5314 7 18.4814 7.00046 19.208 7.0918C19.9221 7.18158 20.3505 7.35254 20.6719 7.6416L20.8584 7.82812C21.1475 8.14949 21.3184 8.57789 21.4082 9.29199C21.4995 10.0186 21.5 10.9687 21.5 12.2979V14.5C21.5 16.3996 21.4993 17.7741 21.3584 18.8223C21.2194 19.8561 20.952 20.4972 20.4746 20.9746C19.9972 21.452 19.3561 21.7194 18.3223 21.8584C17.2741 21.9993 15.8996 22 14 22H10C8.10039 22 6.7259 21.9993 5.67773 21.8584C4.64394 21.7194 4.0028 21.452 3.52539 20.9746C3.048 20.4973 2.78059 19.8561 2.6416 18.8223C2.50071 17.7741 2.5 16.3996 2.5 14.5V7.4502L2.50879 6.42676C2.51664 6.17951 2.53138 6.00636 2.56055 5.85156C2.82768 4.43574 3.93574 3.32768 5.35156 3.06055C5.66151 3.00214 6.04539 3 6.9502 3Z"
        stroke="#A1A1A1"
      />
      <path
        d="M12.25 10.5C12.25 10.0858 12.5858 9.75 13 9.75H18C18.4142 9.75 18.75 10.0858 18.75 10.5C18.75 10.9142 18.4142 11.25 18 11.25H13C12.5858 11.25 12.25 10.9142 12.25 10.5Z"
        fill="#A1A1A1"
      />
    </svg>
  );
}
